<div id="print-section"
     style="width:100%; font-family:Arial, sans-serif; font-size:12px; border:1px solid black; padding:5px;">

  <!-- ================= HEADER ================= -->
  <table style="width:100%; border-bottom:1px solid black; ">
    <tr>
      <td style="text-align:center;width:31%; font-weight:bold; font-size:18px;">
        हिंदुस्तान प्रकाशन संस्था
      </td>

      <td style="text-align:center;width:28%; font-weight:bold; font-size:18px;">
        Business Report
      </td>

      <td style="text-align:right;width:40%; font-weight:bold;font-size:18px;">
        दिनांक : {{ today | date:'dd-MM-yyyy' }}
      </td>
    </tr>

    <tr>
      <td style="text-align:center; font-weight:bold;font-size:18px;">
        विवेक पुस्तक प्रकाशन
      </td>

      <td style="text-align:center; font-weight:bold;font-size:18px;">
        Monthwise
      </td>

      <td style="text-align:right;font-weight:bold;font-size:18px;">
        From {{ startDate | date:'dd-MM-yyyy' }}
        To {{ endDate | date:'dd-MM-yyyy' }}
      </td>
    </tr>
  </table>

  <!-- ================= TABLE ================= -->
  <table style="width:100%; border-collapse:collapse; table-layout:fixed;" border="1">

    <!-- HEADER -->
    <thead style="background-color:#f5c518; text-align:center;">
      <tr>
        <th style="width:50px;">अ.क्र.</th>
        <th style="width:120px;">महिना</th>
        <th style="width:120px;">बिलींग रक्कम</th>
        <th style="width:120px;">जमा रु.</th>
         <th style="width:120px;">क्रेडिट नोट रक्कम</th>
        <th style="width:130px;">येणे बाकी</th>
      </tr>
    </thead>

    <!-- BODY -->
    <tbody>
      <tr *ngFor="let row of monthRows; let i = index" style="text-align:center;">

        <td>{{ i + 1 }}</td>

        <td>{{ row.month }}</td>

        <!-- ✅ TOTAL INVOICE -->
        <td style="text-align:right;">{{ row.chaluVarsh  }}</td>

        <!-- ✅ PAID -->
        <td style="text-align:right;">
          {{ row.jama  }}
        </td>
         <td style="text-align:right;">
          {{ row.crdtnote_total  }}
        </td>

        <!-- ✅ REMAINING -->
        <td style="text-align:right;">
          {{ row.yeneBaki  }}
        </td>

      </tr>
    </tbody>

    <!-- FOOTER -->
   <tfoot style="background-color:#c8753f;font-weight:bold;">
  <tr style="text-align:center;">
    <td colspan="2">एकूण</td>

    <!-- चालू वर्ष -->
    <td style="text-align:right;">
      {{ grandTotal.chaluVarsh  }}
    </td>

    <!-- जमा -->
    <td style="text-align:right;">
      {{ grandTotal.jama }}
    </td>

    <!-- क्रेडिट नोट -->
    <td style="text-align:right;">
      {{ grandTotal.crdtnote_total  }}
    </td>

    <!-- येणे बाकी -->
    <td style="text-align:right;">
      {{ grandTotal.yeneBaki  }}
    </td>
  </tr>
</tfoot>

  </table>

  <!-- ================= BUTTONS ================= -->
  <div class="noPrint" style="margin-top:15px; text-align:center;">
    <button mat-raised-button color="primary"
            (click)="exportExcel('Book_InDetail_Officewise')">
      📊 Export
    </button>

    <button mat-raised-button color="accent"
            (click)=" printPageA4()">
      🖨️ Print
    </button>

    <button mat-button mat-dialog-close>
      ❌ Close
    </button>
  </div>

</div>